import { WorkflowState } from '@amzn/awscat-pattern-library-service-model';

/**
 * Workflow states backed by a publication that the read-only `/view` route can
 * open. Excludes in-progress and tech-review states (e.g. FINALIZING) that have
 * no publication under the default classifier.
 */
const PUBLICATION_VIEWABLE_STATES: ReadonlySet<WorkflowState> = new Set([
  WorkflowState.PUBLISHED,
  WorkflowState.FINALIZED,
  WorkflowState.DISTRIBUTED,
  WorkflowState.REVOKED,
]);

/** True when a workflow version can be opened as a publication in the `/view` route. */
export function isPublicationViewable(state: WorkflowState): boolean {
  return PUBLICATION_VIEWABLE_STATES.has(state);
}
